function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { c as createCommonjsModule, a as commonjsGlobal } from './_commonjsHelpers.js';
import { d as defineCustomElement$4 } from './date-picker-slider.js';
import { d as defineCustomElement$3 } from './flex.js';
import { d as defineCustomElement$2 } from './icon.js';
import { d as defineCustomElement$1 } from './text.js';
var dayjs_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e();
  }(commonjsGlobal, function () {
    var t = 1e3,
        e = 6e4,
        n = 36e5,
        r = "millisecond",
        i = "second",
        s = "minute",
        u = "hour",
        a = "day",
        o = "week",
        c = "month",
        f = "quarter",
        h = "year",
        d = "date",
        l = "Invalid Date",
        $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function ordinal(t) {
        var e = ["th", "st", "nd", "rd"],
            n = t % 100;
        return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
      }
    },
        m = function m(t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
        v = {
      s: m,
      z: function z(t) {
        var e = -t.utcOffset(),
            n = Math.abs(e),
            r = Math.floor(n / 60),
            i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
            i = e.clone().add(r, c),
            s = n - i < 0,
            u = e.clone().add(r + (s ? -1 : 1), c);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function a(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function p(t) {
        return {
          M: c,
          y: h,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: f
        }[t] || String(t || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(t) {
        return void 0 === t;
      }
    },
        g = "en",
        D = {};

    D[g] = M;

    var p = "$isDayjsObject",
        S = function S(t) {
      return t instanceof _ || !(!t || !t[p]);
    },
        w = function t(e, n, r) {
      var i;
      if (!e) return g;

      if ("string" == typeof e) {
        var s = e.toLowerCase();
        D[s] && (i = s), n && (D[s] = n, i = s);
        var u = e.split("-");
        if (!i && u.length > 1) return t(u[0]);
      } else {
        var a = e.name;
        D[a] = e, i = a;
      }

      return !r && i && (g = i), i || !r && g;
    },
        O = function O(t, e) {
      if (S(t)) return t.clone();
      var n = "object" == _typeof(e) ? e : {};
      return n.date = t, n.args = arguments, new _(n);
    },
        b = v;

    b.l = w, b.i = S, b.w = function (t, e) {
      return O(t, {
        locale: e.$L,
        utc: e.$u,
        x: e.$x,
        $offset: e.$offset
      });
    };

    var _ = function () {
      function M(t) {
        this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
      }

      var m = M.prototype;
      return m.parse = function (t) {
        this.$d = function (t) {
          var e = t.date,
              n = t.utc;
          if (null === e) return new Date(NaN);
          if (b.u(e)) return new Date();
          if (e instanceof Date) return new Date(e);

          if ("string" == typeof e && !/Z$/i.test(e)) {
            var r = e.match($);

            if (r) {
              var i = r[2] - 1 || 0,
                  s = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
            }
          }

          return new Date(e);
        }(t), this.init();
      }, m.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, m.$utils = function () {
        return b;
      }, m.isValid = function () {
        return !(this.$d.toString() === l);
      }, m.isSame = function (t, e) {
        var n = O(t);
        return this.startOf(e) <= n && n <= this.endOf(e);
      }, m.isAfter = function (t, e) {
        return O(t) < this.startOf(e);
      }, m.isBefore = function (t, e) {
        return this.endOf(e) < O(t);
      }, m.$g = function (t, e, n) {
        return b.u(t) ? this[e] : this.set(n, t);
      }, m.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m.valueOf = function () {
        return this.$d.getTime();
      }, m.startOf = function (t, e) {
        var n = this,
            r = !!b.u(e) || e,
            f = b.p(t),
            l = function l(t, e) {
          var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
          return r ? i : i.endOf(a);
        },
            $ = function $(t, e) {
          return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
        },
            y = this.$W,
            M = this.$M,
            m = this.$D,
            v = "set" + (this.$u ? "UTC" : "");

        switch (f) {
          case h:
            return r ? l(1, 0) : l(31, 11);

          case c:
            return r ? l(1, M) : l(0, M + 1);

          case o:
            var g = this.$locale().weekStart || 0,
                D = (y < g ? y + 7 : y) - g;
            return l(r ? m - D : m + (6 - D), M);

          case a:
          case d:
            return $(v + "Hours", 0);

          case u:
            return $(v + "Minutes", 1);

          case s:
            return $(v + "Seconds", 2);

          case i:
            return $(v + "Milliseconds", 3);

          default:
            return this.clone();
        }
      }, m.endOf = function (t) {
        return this.startOf(t, !1);
      }, m.$set = function (t, e) {
        var n,
            o = b.p(t),
            f = "set" + (this.$u ? "UTC" : ""),
            l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
            $ = o === a ? this.$D + (e - this.$W) : e;

        if (o === c || o === h) {
          var y = this.clone().set(d, 1);
          y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
        } else l && this.$d[l]($);

        return this.init(), this;
      }, m.set = function (t, e) {
        return this.clone().$set(t, e);
      }, m.get = function (t) {
        return this[b.p(t)]();
      }, m.add = function (r, f) {
        var d,
            l = this;
        r = Number(r);

        var $ = b.p(f),
            y = function y(t) {
          var e = O(l);
          return b.w(e.date(e.date() + Math.round(t * r)), l);
        };

        if ($ === c) return this.set(c, this.$M + r);
        if ($ === h) return this.set(h, this.$y + r);
        if ($ === a) return y(1);
        if ($ === o) return y(7);
        var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
            m = this.$d.getTime() + r * M;
        return b.w(m, this);
      }, m.subtract = function (t, e) {
        return this.add(-1 * t, e);
      }, m.format = function (t) {
        var e = this,
            n = this.$locale();
        if (!this.isValid()) return n.invalidDate || l;

        var r = t || "YYYY-MM-DDTHH:mm:ssZ",
            i = b.z(this),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = n.weekdays,
            c = n.months,
            f = n.meridiem,
            h = function h(t, n, i, s) {
          return t && (t[n] || t(e, r)) || i[n].slice(0, s);
        },
            d = function d(t) {
          return b.s(s % 12 || 12, t, "0");
        },
            $ = f || function (t, e, n) {
          var r = t < 12 ? "AM" : "PM";
          return n ? r.toLowerCase() : r;
        };

        return r.replace(y, function (t, r) {
          return r || function (t) {
            switch (t) {
              case "YY":
                return String(e.$y).slice(-2);

              case "YYYY":
                return b.s(e.$y, 4, "0");

              case "M":
                return a + 1;

              case "MM":
                return b.s(a + 1, 2, "0");

              case "MMM":
                return h(n.monthsShort, a, c, 3);

              case "MMMM":
                return h(c, a);

              case "D":
                return e.$D;

              case "DD":
                return b.s(e.$D, 2, "0");

              case "d":
                return String(e.$W);

              case "dd":
                return h(n.weekdaysMin, e.$W, o, 2);

              case "ddd":
                return h(n.weekdaysShort, e.$W, o, 3);

              case "dddd":
                return o[e.$W];

              case "H":
                return String(s);

              case "HH":
                return b.s(s, 2, "0");

              case "h":
                return d(1);

              case "hh":
                return d(2);

              case "a":
                return $(s, u, !0);

              case "A":
                return $(s, u, !1);

              case "m":
                return String(u);

              case "mm":
                return b.s(u, 2, "0");

              case "s":
                return String(e.$s);

              case "ss":
                return b.s(e.$s, 2, "0");

              case "SSS":
                return b.s(e.$ms, 3, "0");

              case "Z":
                return i;
            }

            return null;
          }(t) || i.replace(":", "");
        });
      }, m.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m.diff = function (r, d, l) {
        var $,
            y = this,
            M = b.p(d),
            m = O(r),
            v = (m.utcOffset() - this.utcOffset()) * e,
            g = this - m,
            D = function D() {
          return b.m(y, m);
        };

        switch (M) {
          case h:
            $ = D() / 12;
            break;

          case c:
            $ = D();
            break;

          case f:
            $ = D() / 3;
            break;

          case o:
            $ = (g - v) / 6048e5;
            break;

          case a:
            $ = (g - v) / 864e5;
            break;

          case u:
            $ = g / n;
            break;

          case s:
            $ = g / e;
            break;

          case i:
            $ = g / t;
            break;

          default:
            $ = g;
        }

        return l ? $ : b.a($);
      }, m.daysInMonth = function () {
        return this.endOf(c).$D;
      }, m.$locale = function () {
        return D[this.$L];
      }, m.locale = function (t, e) {
        if (!t) return this.$L;
        var n = this.clone(),
            r = w(t, e, !0);
        return r && (n.$L = r), n;
      }, m.clone = function () {
        return b.w(this.$d, this);
      }, m.toDate = function () {
        return new Date(this.valueOf());
      }, m.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m.toISOString = function () {
        return this.$d.toISOString();
      }, m.toString = function () {
        return this.$d.toUTCString();
      }, M;
    }(),
        k = _.prototype;

    return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
      k[t[1]] = function (e) {
        return this.$g(e, t[0], t[1]);
      };
    }), O.extend = function (t, e) {
      return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function (t) {
      return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
  });
});
createCommonjsModule(function (module, exports) {
  !function (e, n) {
    module.exports = n(dayjs_min);
  }(commonjsGlobal, function (e) {
    function n(e) {
      return e && "object" == _typeof(e) && "default" in e ? e : {
        default: e
      };
    }

    var t = n(e),
        i = {
      name: "fr",
      weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
      weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
      weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
      months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
      monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
      weekStart: 1,
      yearStart: 4,
      formats: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans"
      },
      ordinal: function ordinal(e) {
        return "" + e + (1 === e ? "er" : "");
      }
    };
    return t.default.locale(i, null, !0), i;
  });
});
createCommonjsModule(function (module, exports) {
  !function (e, n) {
    module.exports = n(dayjs_min);
  }(commonjsGlobal, function (e) {
    function n(e) {
      return e && "object" == _typeof(e) && "default" in e ? e : {
        default: e
      };
    }

    var t = n(e),
        a = {
      s: "ein paar Sekunden",
      m: ["eine Minute", "einer Minute"],
      mm: "%d Minuten",
      h: ["eine Stunde", "einer Stunde"],
      hh: "%d Stunden",
      d: ["ein Tag", "einem Tag"],
      dd: ["%d Tage", "%d Tagen"],
      M: ["ein Monat", "einem Monat"],
      MM: ["%d Monate", "%d Monaten"],
      y: ["ein Jahr", "einem Jahr"],
      yy: ["%d Jahre", "%d Jahren"]
    };

    function i(e, n, t) {
      var i = a[t];
      return Array.isArray(i) && (i = i[n ? 0 : 1]), i.replace("%d", e);
    }

    var r = {
      name: "de",
      weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
      weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
      weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
      months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
      monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"),
      ordinal: function ordinal(e) {
        return e + ".";
      },
      weekStart: 1,
      yearStart: 4,
      formats: {
        LTS: "HH:mm:ss",
        LT: "HH:mm",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY HH:mm",
        LLLL: "dddd, D. MMMM YYYY HH:mm"
      },
      relativeTime: {
        future: "in %s",
        past: "vor %s",
        s: i,
        m: i,
        mm: i,
        h: i,
        hh: i,
        d: i,
        dd: i,
        M: i,
        MM: i,
        y: i,
        yy: i
      }
    };
    return t.default.locale(r, null, !0), r;
  });
});
var localeData = createCommonjsModule(function (module, exports) {
  !function (n, e) {
    module.exports = e();
  }(commonjsGlobal, function () {
    return function (n, e, t) {
      var r = e.prototype,
          o = function o(n) {
        return n && (n.indexOf ? n : n.s);
      },
          u = function u(n, e, t, r, _u) {
        var i = n.name ? n : n.$locale(),
            a = o(i[e]),
            s = o(i[t]),
            f = a || s.map(function (n) {
          return n.slice(0, r);
        });
        if (!_u) return f;
        var d = i.weekStart;
        return f.map(function (n, e) {
          return f[(e + (d || 0)) % 7];
        });
      },
          i = function i() {
        return t.Ls[t.locale()];
      },
          a = function a(n, e) {
        return n.formats[e] || function (n) {
          return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (n, e, t) {
            return e || t.slice(1);
          });
        }(n.formats[e.toUpperCase()]);
      },
          s = function s() {
        var n = this;
        return {
          months: function months(e) {
            return e ? e.format("MMMM") : u(n, "months");
          },
          monthsShort: function monthsShort(e) {
            return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
          },
          firstDayOfWeek: function firstDayOfWeek() {
            return n.$locale().weekStart || 0;
          },
          weekdays: function weekdays(e) {
            return e ? e.format("dddd") : u(n, "weekdays");
          },
          weekdaysMin: function weekdaysMin(e) {
            return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
          },
          weekdaysShort: function weekdaysShort(e) {
            return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
          },
          longDateFormat: function longDateFormat(e) {
            return a(n.$locale(), e);
          },
          meridiem: this.$locale().meridiem,
          ordinal: this.$locale().ordinal
        };
      };

      r.localeData = function () {
        return s.bind(this)();
      }, t.localeData = function () {
        var n = i();
        return {
          firstDayOfWeek: function firstDayOfWeek() {
            return n.weekStart || 0;
          },
          weekdays: function weekdays() {
            return t.weekdays();
          },
          weekdaysShort: function weekdaysShort() {
            return t.weekdaysShort();
          },
          weekdaysMin: function weekdaysMin() {
            return t.weekdaysMin();
          },
          months: function months() {
            return t.months();
          },
          monthsShort: function monthsShort() {
            return t.monthsShort();
          },
          longDateFormat: function longDateFormat(e) {
            return a(n, e);
          },
          meridiem: n.meridiem,
          ordinal: n.ordinal
        };
      }, t.months = function () {
        return u(i(), "months");
      }, t.monthsShort = function () {
        return u(i(), "monthsShort", "months", 3);
      }, t.weekdays = function (n) {
        return u(i(), "weekdays", null, null, n);
      }, t.weekdaysShort = function (n) {
        return u(i(), "weekdaysShort", "weekdays", 3, n);
      }, t.weekdaysMin = function (n) {
        return u(i(), "weekdaysMin", "weekdays", 2, n);
      };
    };
  });
});
var isBetween = createCommonjsModule(function (module, exports) {
  !function (e, i) {
    module.exports = i();
  }(commonjsGlobal, function () {
    return function (e, i, t) {
      i.prototype.isBetween = function (e, i, s, f) {
        var n = t(e),
            o = t(i),
            r = "(" === (f = f || "()")[0],
            u = ")" === f[1];
        return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
      };
    };
  });
});
dayjs_min.extend(localeData);
dayjs_min.extend(isBetween);
var datePickerDatesCss = "@charset \"UTF-8\";:root{--skp-color-neutral-50:#f7f7f7;--skp-color-neutral-100:#e7e7e7;--skp-color-neutral-200:#cfcece;--skp-color-neutral-300:#b8b6b6;--skp-color-neutral-400:#a09e9e;--skp-color-neutral-500:#888585;--skp-color-neutral-600:#706d6d;--skp-color-neutral-700:#585656;--skp-color-neutral-800:#3f3e3e;--skp-color-neutral-900:#2f2e2e;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative-purple-50:#f5ecfa;--skp-color-alternative-purple-100:#e3c6f0;--skp-color-alternative-purple-200:#d0a0e6;--skp-color-alternative-purple-300:#bd7adc;--skp-color-alternative-purple-400:#a041cd;--skp-color-alternative-purple-500:#832dab;--skp-color-alternative-purple-600:#692489;--skp-color-alternative-purple-700:#4f1b67;--skp-color-alternative-purple-800:#341244;--skp-color-alternative-purple-900:#1a0922;--skp-color-alternative-green-50:#f7fae5;--skp-color-alternative-green-100:#e7f0b0;--skp-color-alternative-green-200:#d7e67c;--skp-color-alternative-green-300:#c7db47;--skp-color-alternative-green-400:#aabf25;--skp-color-alternative-green-500:#8e9f1f;--skp-color-alternative-green-600:#717f19;--skp-color-alternative-green-700:#556013;--skp-color-alternative-green-800:#39400c;--skp-color-alternative-green-900:#1c2006;--skp-color-alternative-sky-50:#e8f7fb;--skp-color-alternative-sky-100:#bae8f2;--skp-color-alternative-sky-200:#8dd9e9;--skp-color-alternative-sky-300:#5fc9e1;--skp-color-alternative-sky-400:#31bad8;--skp-color-alternative-sky-500:#239fba;--skp-color-alternative-sky-600:#1c7f95;--skp-color-alternative-sky-700:#155f6f;--skp-color-alternative-sky-800:#0e3f4a;--skp-color-alternative-sky-900:#072025;--skp-color-success-50:#e4faf4;--skp-color-success-100:#aef1dd;--skp-color-success-200:#79e7c6;--skp-color-success-300:#43deaf;--skp-color-success-400:#22c090;--skp-color-success-500:#1da57c;--skp-color-success-600:#19906d;--skp-color-success-700:#12674e;--skp-color-success-800:#0b3e2f;--skp-color-success-900:#041510;--skp-color-warning-50:#ffefe6;--skp-color-warning-100:#ffcfb6;--skp-color-warning-200:#ffb084;--skp-color-warning-300:#ff9054;--skp-color-warning-400:#ff7022;--skp-color-warning-500:#ff600a;--skp-color-warning-600:#e85100;--skp-color-warning-700:#a63a00;--skp-color-warning-800:#632300;--skp-color-warning-900:#210c00;--skp-color-error-50:#fcecec;--skp-color-error-100:#f7c5c5;--skp-color-error-200:#f29e9e;--skp-color-error-300:#ed7777;--skp-color-error-400:#e85050;--skp-color-error-500:#e53d3d;--skp-color-error-600:#e01e1e;--skp-color-error-700:#a01515;--skp-color-error-800:#600d0d;--skp-color-error-900:#200404;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:\"roboto\", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-date-picker-dates-slider{margin-bottom:var(--skp-size-2)}.skp-date-picker-dates-table{border-spacing:0}.skp-date-picker-dates-day{padding:0;outline:none}.skp-date-picker-dates-day-name{color:var(--skp-color-neutral-700);height:40px}.skp-date-picker-dates-button{height:40px;width:42px;border:none;background:none;cursor:pointer}.skp-date-picker-dates-button:hover{background:var(--skp-color-neutral-50)}.skp-date-picker-dates-button:active,.skp-date-picker-dates-button:focus{border:1px solid var(--skp-color-primary-300);border-radius:var(--skp-size-1);outline:none}.skp-date-picker-dates-button.active{background:var(--skp-color-primary-500) !important;border-radius:var(--skp-size-1)}.skp-date-picker-dates-button.active:hover{background:var(--skp-color-primary-300) !important}.skp-date-picker-dates-button.active:active,.skp-date-picker-dates-button.active:focus{border:2px solid var(--skp-color-white)}.skp-date-picker-dates-button.selected{background:var(--skp-color-neutral-50)}.skp-date-picker-dates-button.current-day{color:var(--skp-color-primary-400)}";
var DatePickerDates = /*@__PURE__*/proxyCustomElement( /*#__PURE__*/function (_HTMLElement) {
  _inherits(DatePickerDates, _HTMLElement);

  var _super = _createSuper(DatePickerDates);

  function DatePickerDates() {
    var _this;

    _classCallCheck(this, DatePickerDates);

    _this = _super.call(this);

    _this.__registerHost();

    _this.skpSelectDate = createEvent(_assertThisInitialized(_this), "skpSelectDate", 7);
    _this.skpMonthChange = createEvent(_assertThisInitialized(_this), "skpMonthChange", 7);
    _this.focusDate = undefined;
    _this.currentMonth = undefined;
    _this.endDay = undefined;
    _this.isRange = false;
    _this.locale = undefined;
    _this.order = 'first';
    _this.goBackDisabled = false;
    _this.skpClass = '';
    _this.startDay = undefined;
    return _this;
  }

  _createClass(DatePickerDates, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusDate) {
        this.focusDay(this.focusDate);
        this.focusDate = null;
      }
    }
  }, {
    key: "selectDate",
    value: function selectDate(e) {
      e.stopPropagation();
      if (!e.target.closest('button')) return;
      var day = dayjs_min(e.target.closest('button').dataset.date);
      this.focusDate = day;
      var noStartDay = !this.startDay;
      var noEndDay = this.startDay && !this.endDay;
      var isRangeSelected = this.startDay && this.endDay;

      if (!this.isRange) {
        this.skpSelectDate.emit({
          start: this.checkIsEqual(this.startDay, day) ? null : day
        });
        return;
      }

      if (noStartDay) {
        this.skpSelectDate.emit({
          start: day,
          end: this.endDay
        });
        return;
      }

      if (noEndDay) {
        if (this.checkIsEqual(this.startDay, day)) {
          this.skpSelectDate.emit({
            start: null,
            end: this.endDay
          });
          return;
        }

        if (day > this.startDay) {
          this.skpSelectDate.emit({
            start: this.startDay,
            end: day
          });
        } else {
          this.skpSelectDate.emit({
            end: this.startDay,
            start: day
          });
        }

        return;
      }

      if (isRangeSelected) {
        if (this.checkIsEqual(this.startDay, day)) {
          this.skpSelectDate.emit({
            start: this.endDay,
            end: null
          });
          return;
        }

        if (this.checkIsEqual(this.endDay, day)) {
          this.skpSelectDate.emit({
            start: this.startDay,
            end: null
          });
          return;
        }

        if (day > this.endDay) {
          this.skpSelectDate.emit({
            start: this.startDay,
            end: day
          });
          return;
        }

        if (day < this.startDay) {
          this.skpSelectDate.emit({
            start: day,
            end: this.endDay
          });
          return;
        }

        if (this.endDay.diff(day, 'day') <= day.diff(this.startDay, 'day')) {
          this.skpSelectDate.emit({
            start: this.startDay,
            end: day
          });
        } else {
          this.skpSelectDate.emit({
            start: day,
            end: this.endDay
          });
        }
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (!e.target.closest('button')) return;
      var day = dayjs_min(e.target.closest('button').dataset.date);
      var dayDiff = 0;

      switch (e.key) {
        case 'Right':
        case 'ArrowRight':
          dayDiff = 1;
          break;

        case 'Left':
        case 'ArrowLeft':
          dayDiff = -1;
          break;

        case 'Down':
        case 'ArrowDown':
          dayDiff = 7;
          break;

        case 'Up':
        case 'ArrowUp':
          dayDiff = -7;
          break;
      }

      var nextDate = day.add(dayDiff, 'day');

      if (nextDate.isSame(this.currentMonth, 'month')) {
        this.focusDay(nextDate);
      } else {
        document.querySelector('.skp-date-picker').focus();
        this.skpMonthChange.emit({
          date: nextDate.set('date', 1),
          order: this.order
        });
        this.focusDate = nextDate;
      }
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth() {
      var _this2 = this;

      return new Array(6).fill(new Array(7).fill(undefined)).map(function (row, rowIndex) {
        return row.map(function (_, dayIndex) {
          return _this2.currentMonth.set('date', 7 * rowIndex + dayIndex - _this2.currentMonth.day() + 1);
        });
      }).map(function (row) {
        return row.map(function (day) {
          return day.month() === _this2.currentMonth.month() ? day : null;
        });
      }).filter(function (row) {
        return row.some(Boolean);
      });
    }
  }, {
    key: "checkIsEqual",
    value: function checkIsEqual(firstDate, secondDate) {
      return (firstDate === null || firstDate === void 0 ? void 0 : firstDate.format('DD MM YYYY')) === (secondDate === null || secondDate === void 0 ? void 0 : secondDate.format('DD MM YYYY'));
    }
  }, {
    key: "focusDay",
    value: function focusDay(currentDay) {
      var _a;

      (_a = this.table.querySelector("[data-date=\"".concat(currentDay.toISOString(), "\"]"))) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return h("div", {
        class: "skp-date-picker-dates ".concat(this.skpClass)
      }, h("div", {
        class: 'skp-date-picker-dates-slider'
      }, h("skp-date-picker-slider", {
        month: this.currentMonth,
        locale: this.locale,
        order: this.order,
        goBackDisabled: this.goBackDisabled
      })), h("table", {
        role: 'grid',
        class: 'skp-date-picker-dates-table',
        onClick: this.selectDate.bind(this),
        onKeyDown: this.handleKeyDown.bind(this),
        ref: function ref(el) {
          return _this3.table = el;
        }
      }, h("thead", null, h("tr", null, dayjs_min().locale(this.locale).localeData().weekdaysMin().map(function (day) {
        return h("th", {
          class: 'skp-date-picker-dates-day skp-date-picker-dates-day-name'
        }, h("skp-text", {
          text: day,
          size: 'small'
        }));
      }))), h("tbody", null, this.getDaysInMonth().map(function (row) {
        return h("tr", null, row.map(function (day) {
          return day ? h("td", {
            class: 'skp-date-picker-dates-day'
          }, h("button", {
            "data-date": day.toISOString(),
            "aria-selected": _this3.checkIsEqual(_this3.startDay, day) || _this3.checkIsEqual(_this3.endDay, day),
            class: "\n                        skp-date-picker-dates-button\n                        ".concat(_this3.checkIsEqual(_this3.startDay, day) || _this3.checkIsEqual(_this3.endDay, day) ? 'active' : '', "\n                        ").concat(_this3.isRange && _this3.startDay && _this3.endDay && dayjs_min(day).isBetween(_this3.startDay, _this3.endDay, null, '[]') ? 'selected' : '', "\n                        ").concat(_this3.checkIsEqual(dayjs_min(), day) ? 'current-day' : '', "\n                      ")
          }, h("skp-text", {
            text: day.get('date'),
            size: 'small',
            color: _this3.checkIsEqual(_this3.startDay, day) || _this3.checkIsEqual(_this3.endDay, day) ? '--skp-color-white' : '--skp-color-neutral-900'
          }))) : h("td", null, h("div", {
            class: 'skp-date-picker-dates-day'
          }));
        }));
      }))));
    }
  }], [{
    key: "style",
    get: function get() {
      return datePickerDatesCss;
    }
  }]);

  return DatePickerDates;
}(HTMLElement), [0, "skp-date-picker-dates", {
  "currentMonth": [8, "current-month"],
  "endDay": [8, "end-day"],
  "isRange": [4, "is-range"],
  "locale": [8],
  "order": [1],
  "goBackDisabled": [4, "go-back-disabled"],
  "skpClass": [1, "skp-class"],
  "startDay": [8, "start-day"],
  "focusDate": [32]
}]);

function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["skp-date-picker-dates", "skp-date-picker-slider", "skp-flex", "skp-icon", "skp-text"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "skp-date-picker-dates":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, DatePickerDates);
        }

        break;

      case "skp-date-picker-slider":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }

        break;

      case "skp-flex":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }

        break;

      case "skp-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }

        break;

      case "skp-text":
        if (!customElements.get(tagName)) {
          defineCustomElement$1();
        }

        break;
    }
  });
}

export { DatePickerDates as D, dayjs_min as a, defineCustomElement as d };